<template>
  <div style="cursor: pointer">
    <apexchart
      height="100%"
      type="bar"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>
<script>
import CompraAPI from "./../../api/compra";
import { mapGetters } from "vuex";

import { options } from "./fornecedor/OptionsChartDetalhesFornecedor";

export default {
  data: () => ({
    options: options,
    series: [],
    maxValor: 0,
  }),
  computed: {
    ...mapGetters({
      getFornecedor: "fornecedor/getFornecedor",
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
    }),
    maxEscala() {
      return this.maxValor + this.maxValor / 4;
    },
    yaxis: function () {
      return {
        title: {
          text: "Análise de Compras vs Vendas",
          style: {
            color: "#000",
            fontSize: "12px",
            fontWeight: 600,
            cssClass: "apexcharts-yaxis-title",
          },
        },
        labels: {
          formatter: (n) => {
            return this.formatter(n) || "";
          },
          style: {
            color: "#000",
            cssClass: "apexcharts-yaxis-title",
          },
        },
        forceNiceScale: true,
        max: this.maxEscala,
      };
    },
  },
  watch: {
    grupoCompra: function () {
      this.buscarDadosGrafico();
    },
    getFornecedor: function () {
      this.buscarDadosGrafico();
    },
    filialCompra: function () {
      this.buscarDadosGrafico();
    },
  },
  created() {
    this.buscarDadosGrafico();
  },
  methods: {
    buscarDadosGrafico: function () {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        fornecedor: this.getFornecedor.id,
        grupo: this.grupoCompra,
        filial_compra: this.filialCompra,
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores || 'N'
      };
      this.$store.dispatch("loading/habilitarLoading", true);
      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getDadosGraficoFornecedorGrupo(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            const { compras } = response.data.movimentacoes;
            const { saidas } = response.data.movimentacoes;

            compras.concat(saidas).forEach((item) => {
              if (parseInt(item) > this.maxValor) {
                this.maxValor = parseInt(item);
              }
            });

            this.options = {
              yaxis: this.yaxis,
              labels: response.data.movimentacoes.ref,
            };

            this.series = [
              {
                name: "Compras",
                color: "rgba(4, 53, 84, 0.6)",
                data: response.data.movimentacoes.compras,
              },
              {
                name: "Entradas",
                color: "rgba(4, 53, 84, 1)",
                data: response.data.movimentacoes.entradas,
              },
              {
                name: "Vendas",
                color: "rgba(214, 14, 43,1)",
                data: response.data.movimentacoes.saidas,
              },
            ];
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
          })
      );
    },

    formatter: function (n) {
      var ranges = [
        { divider: 1e15, suffix: "P" },
        { divider: 1e12, suffix: "T" },
        { divider: 1e9, suffix: "G" },
        { divider: 1e6, suffix: "M" },
        { divider: 1e3, suffix: "k" },
      ];

      for (var i = 0; i < ranges.length; i++) {
        if (n >= ranges[i].divider) {
          return (
            (Math.round(n) / ranges[i].divider).toFixed(0).toString() +
            ranges[i].suffix
          );
        }
      }

      return n;
    },
  },
};
</script>
